import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
export default function CommentsInspectorControls(_ref) {
  let {
    attributes: {
      TagName
    },
    setAttributes
  } = _ref;
  return createElement(InspectorControls, null, createElement(InspectorControls, {
    __experimentalGroup: "advanced"
  }, createElement(SelectControl, {
    label: __('HTML element'),
    options: [{
      label: __('Default (<div>)'),
      value: 'div'
    }, {
      label: '<section>',
      value: 'section'
    }, {
      label: '<aside>',
      value: 'aside'
    }],
    value: TagName,
    onChange: value => setAttributes({
      tagName: value
    })
  })));
}
//# sourceMappingURL=comments-inspector-controls.js.map